import { isNull } from "lodash";

export default function(value) {
  return isNull(value) ? "" : value;
}
